import assertClassBrand from "./assertClassBrand.js";
export default function _classPrivateFieldGet2(s, a) {
  return s.get(assertClassBrand(s, a));
}